import React from 'react';
import { device } from '../../utils/responsive_utilities';
import Styled from 'styled-components';
import { fontQuicksand } from './mixin';
import { white } from '../loggedout/shared-styles/Colors';

const SavedCardsContainer = ({
  settings,
  selectedCardId,
  savedCardsHandler,
  addCardText = "+ Add New Card",
  setPaymentElementError,
  order
}) => {
  let cardList = settings.stripeCards;
  if (order === "defaultCardFirst") {
    cardList.sort((a, b) => (a.is_default === b.is_default ? 0 : a.is_default ? -1 : 1));
  }

  return (
    cardList.length > 0 && (
      <SavedCardsWrapper className="payment-options" id="paymentOptions">
        {cardList.map((val) => (
          <SavedCardItem
            card={val}
            savedCardsHandler={savedCardsHandler}
            selectedCardId={selectedCardId}
            setPaymentElementError={setPaymentElementError}
          />
        ))}
        {selectedCardId && (
          <SavedCard onClick={() => savedCardsHandler(null)}>
						{/* <a className="add-new-card" href="javascript:void(0)" > */}
            {addCardText}
            {/* </a> */}
          </SavedCard>
        )}
      </SavedCardsWrapper>
    )
  );
};

const SavedCardItem = function ({ card, savedCardsHandler, selectedCardId, setPaymentElementError }) {
  let isSelected = selectedCardId == card.stripe_id;
  let cardBrand = card.brand.replace(/\s+/g, '-').toLowerCase();
  return (
    <SavedCard
      isSelected={isSelected}
      onClick={() => {
        savedCardsHandler(card.stripe_id);
        setPaymentElementError && setPaymentElementError(false)
      }}
    >
      <div>
        <input type="radio" checked={isSelected} />
        <label>
          <p>
            <span className="hidden-card-nmbr">**** **** ****</span>{' '}
            {card.last4}
          </p>
          {/* <span>{` $`}</span> */}
        </label>
      </div>
      <span
        className={cardBrand + ' card-brand-logo card-brand-logo-new-page'}
      ></span>
    </SavedCard>
  );
};

export const SavedCard = Styled.li`
  cursor: pointer;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  justify-content: space-between;
  background-color: ${(props) =>
    props.isSelected ? 'rgba(79, 82, 195, 0.4)' : 'transparent'};
  margin-bottom: 1.6rem;
  border: 1px solid #6E71DD;
  border-radius: 1.2rem;
  height: 7.2rem;
  padding: 0 2.4rem;
  ${fontQuicksand(1.6, 2, 7)};
  color: #fff;
  .card-brand-logo-new-page {
    padding: 0;
    width: 5.5rem;
    height: 4rem;
  }
  input[type="radio"] {
    opacity: 0;
    width:0;
    height:0;

  }
  input[type="radio"]:checked + label::after {
    border-width: 0.4rem;
    background-color: #2284E2;
  }

  label {
    cursor: pointer;
    position: relative;
    padding-left: 2rem;
    &:after {
      content: '';
      width: 1.6rem;
      height: 1.6rem;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      position: absolute;
      border: 0.1rem solid ${white};
      border-radius: 50%;
      box-sizing: border-box;
      background-color: transparent;
    }
  }
  p {
    display: inline-block;
  }
  .hidden-card-nmbr {
    ${fontQuicksand(2.4, 2.8, 7)};
    vertical-align: sub;
  }
  @media ${device.PhoneLargeScreen} {
    ${fontQuicksand(1.4, 1.8, 7)};
    height: 4.8rem;
    .hidden-card-nmbr {
    ${fontQuicksand(1.8, 2.2, 7)};
  }
  }
  @media ${device.Phone} {
  ${fontQuicksand(1.4, 1.8, 7)};
  height: 4.8rem;
  .hidden-card-nmbr {
    ${fontQuicksand(1.8, 2.2, 7)};
  }
  }
`;

export const SavedCardsWrapper = Styled.ul`
  width: 47rem;
  box-sizing: border-box;
  margin: 0 auto;
  
  @media ${device.PhoneLargeScreen} {
    width: 37rem;
  }
  @media ${device.Phone} {
    width: 34rem;
  }
`;

export default SavedCardsContainer;
